"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cxThemeLoader = _interopRequireDefault(require("./Cx/cxThemeLoader"));

var _cxprefixThemeLoader = _interopRequireDefault(require("./CxPrefix/cxprefixThemeLoader"));

/* eslint-disable */
// This file is generated by the generateThemesRegistry script

/**
 * This is the list of registered themes that are used by the CxThemeProvider
 * It is generated from the list of themes in the themes.config.json file
 * type {themePropType[]}
 */
var registeredThemes = {
  Cx: {
    themeName: "Cx",
    themeDisplay: "CX Theme",
    themeLoader: _cxThemeLoader.default,
    themePrefix: ""
  },
  CxPrefix: {
    themeName: "CxPrefix",
    themeDisplay: "CX Prefixed Theme",
    themeLoader: _cxprefixThemeLoader.default,
    themePrefix: "cx-"
  }
};
var _default = registeredThemes;
exports.default = _default;